"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreePreviewService = exports.freePreviewService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../auth-suite-sdk-setup/models");
var access_1 = require("../access");
var settings_1 = require("../settings");
var requestRoute = "access/freePreview";
var promoCodeDetailsRoute = "".concat(requestRoute, "/promoCode");
var startFreePreviewForTrustedLogin = function () {
    return requestStartFreePreview(requestRoute);
};
var startFreePreview = function (mvpdCode) {
    var startFreePreviewRoute = "".concat(requestRoute, "/").concat(mvpdCode);
    return requestStartFreePreview(startFreePreviewRoute);
};
var isAvailable = function () {
    return checkStatus(settings_1.FreePreviewStatus.Available);
};
var isInUse = function () {
    return checkStatus(settings_1.FreePreviewStatus.InUse);
};
var secondsLeft = function () {
    return access_1.accessService.checkAccessStatus({}).then(function (response) {
        var freePreviewAccessMethod = response.accessMethodsInUse.find(function (method) { return method.type === models_1.ContentAccessMethodType.FreePreview; });
        return freePreviewAccessMethod ? freePreviewAccessMethod.expiresInSeconds : 0;
    });
};
var getPromoCodeDetails = function (request) {
    var path = "".concat(promoCodeDetailsRoute, "/").concat(request.providerUserId);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: path,
    });
};
var requestStartFreePreview = function (route) {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        path: route,
    });
};
var getFreePreviewAccessMethodConfiguration = function () {
    return settings_1.settingsService.getAccessMethods().then(function (response) { return response.freePreview; });
};
var checkStatus = function (status) {
    return getFreePreviewAccessMethodConfiguration().then(function (freePreviewData) {
        return freePreviewData && freePreviewData.status === status;
    });
};
var startWinBackPromoCode = function (promoCode) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var requestBody, body;
    return tslib_1.__generator(this, function (_a) {
        requestBody = { promoCode: promoCode };
        body = JSON.stringify(requestBody);
        return [2 /*return*/, auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                path: "".concat(promoCodeDetailsRoute, "/start"),
                body: body,
            })];
    });
}); };
exports.freePreviewService = {
    getPromoCodeDetails: getPromoCodeDetails,
    isAvailable: isAvailable,
    isInUse: isInUse,
    secondsLeft: secondsLeft,
    startFreePreview: startFreePreview,
    startFreePreviewForTrustedLogin: startFreePreviewForTrustedLogin,
    startWinBackPromoCode: startWinBackPromoCode,
};
var FreePreviewService = /** @class */ (function () {
    function FreePreviewService() {
        return exports.freePreviewService;
    }
    return FreePreviewService;
}());
exports.FreePreviewService = FreePreviewService;
